import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';

import './HeatmapButton.custom.scss';

export default function HeatmapButton(props) {
  const { isHeatmapAvailable, isHeatmapDisabled, onHeatmapButtonClick, buttonSize } = props;

  if (!isHeatmapAvailable) {
    return null;
  }

  return (
    <Button
      id="heatmap"
      onClick={() => onHeatmapButtonClick()}
      disabled={isHeatmapDisabled}
      buttonConfig={{
        className: 'result-toolbar-heatmap-button',
        label: 'Bioactivity Visualization',
        type: 'tertiary',
        size: buttonSize,
        e2eName: 'heatmap',
      }}
      iconConfig={{
        name: 'heatmap',
        size: buttonSize,
      }}
    />
  );
}

HeatmapButton.defaultProps = {
  buttonSize: 'sm',
};

HeatmapButton.propTypes = {
  isHeatmapDisabled: PropTypes.bool.isRequired,
  isHeatmapAvailable: PropTypes.bool.isRequired,
  onHeatmapButtonClick: PropTypes.func.isRequired,
  buttonSize: PropTypes.string,
};
